import { gql } from '@apollo/client';

export const SEARCH_CUSTOMER = gql`
query SearchCustomersLegacy($query: String!, $officeIds: [String!]) {
  searchCustomersLegacy(query: $query, officeIds: $officeIds) {
    _id
    firstName
    lastName
    memberId
    phoneNumber
    office {
      officeName
    }
    user {
      firstName
      lastName
    }
  }
}`;
export interface SearchCustomerItem {
    _id: string;
    firstName: string;
    lastName: string;
    memberId: string;
    phoneNumber: string;
    office?: {
        officeName: string;
    };
    user?: {
        firstName: string;
        lastName: string;
    };
}